import React, { useEffect } from "react";
import { getCategories } from "./filter-sidebar.service";
import { useNavigate } from "react-router-dom";

export default function FilterSidebar() {
  const [categories, setCategories] = React.useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = React.useState<string | null>(
    null
  );
  const navigate = useNavigate();

  useEffect(() => {
    getCategories({ limit: 500, page: 1 }).then((response) => {
      setCategories(response.data.results);
    });
  }, []);

  const handleCategoryClick = (categoryId: string) => {
    setSelectedCategory(categoryId);
    if (categoryId === "") {
      return navigate("");
    }
    navigate(`?category=${categoryId}`);
  };

  return (
    <div className="ec-shop-leftside col-lg-3 order-lg-first col-md-12 ">
      <div
        id="shop_sidebar"
        className="is-affixed"
        style={{
          position: "relative",
          height: "935px",
        }}
      >
        <div className="ec-sidebar-heading">
          <h1>Filter Products By</h1>
        </div>
        <div className="ec-sidebar-wrap">
          <div className="ec-sidebar-block">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item category-acc-item">
                <h2
                  className="accordion-header ec-sb-title mobile-cat-titile"
                  id="headingTwo"
                >
                  <button
                    className="accordion-button collapsed ec-sidebar-title"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Category
                  </button>
                </h2>
                <div className="ec-sb-title desktop-cat-titile">
                  <h3 className="ec-sidebar-title">Category</h3>
                </div>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="ec-sb-block-content">
                    <ul>
                      <li key={"all"}>
                        <div className="ec-sidebar-block-item">
                          <input
                            id={"all"}
                            type="radio"
                            checked={selectedCategory === ""}
                            onChange={() => handleCategoryClick("")}
                          />
                          <label htmlFor={"all"}>All</label>
                          <span className="checked" />
                        </div>
                      </li>
                      {categories.map((category) => (
                        <li key={category.id}>
                          <div className="ec-sidebar-block-item">
                            <input
                              id={category.id}
                              type="radio"
                              checked={selectedCategory === category.id}
                              onChange={() => handleCategoryClick(category.id)}
                            />
                            <label htmlFor={category.id}>{category.name}</label>
                            <span className="checked" />
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
